import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
// taken mostly from http://paulsec.github.io/posts/ionic-5-events/ as substitute for events
export class EventsService {
    private fooSubject = new Subject<any>();

    publishData(data: any) {
        this.fooSubject.next(data);
    }

    getObservable(): Subject<any> {
        return this.fooSubject;
    }
}